import { useAuthInfo } from '@amazd/common/hooks/auth';
import { Container } from '@mui/material';
import { SnackbarProvider } from 'hooks/useSnackbar';
import CompanySettingsLayout from 'layouts/CompanySettingsLayout';

import CompanyProfileForm from './companyProfileForm';

const CompanyProfileView = () => {
  const { ownUserType } = useAuthInfo();
  const companyId = ownUserType?.company?.id ?? '';

  return (
    <CompanySettingsLayout>
      <Container maxWidth="md">
        <SnackbarProvider>
          <CompanyProfileForm companyId={companyId} />
        </SnackbarProvider>
      </Container>
    </CompanySettingsLayout>
  );
};

export default CompanyProfileView;
